import { EsriJSON } from 'ol/format';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { MapLayer } from '../MapLayer';
/**
 * Static area overlay loaded from an ESRI/GeoJSON URL — e.g. the
 * Natura-2000 protected-area polygons used on the Sighting page. The
 * source URL must be reachable from the browser (typically a file under
 * `/map_areas/...`); CORS errors surface as an empty layer.
 *
 * Each feature's SITENAME/SITECODE/URL properties are rendered into a
 * popover-friendly `content` HTML string at load time, so clicking a
 * polygon shows the area's metadata.
 */
export class AreaOverlayLayer extends MapLayer {
    constructor(name, title, url, visible = false) {
        super();
        this._name = name;
        this._title = title;
        this._url = url;
        this._initiallyVisible = visible;
    }
    getName() {
        return this._name;
    }
    getTitle() {
        return this._title;
    }
    getOlLayer() {
        if (!this._layer) {
            this._source = new VectorSource();
            this._layer = new VectorLayer({
                source: this._source
            });
            this._layer.setZIndex(50);
            this._layer.setVisible(this._initiallyVisible);
        }
        return this._layer;
    }
    /**
     * Fetch + parse the ESRI JSON feed and populate the source. Safe to
     * call after {@link MapLayer.attachTo} — the layer is added to the
     * map immediately and features stream in once the fetch resolves.
     */
    async loadFromUrl() {
        if (!this._source) {
            return;
        }
        const response = await fetch(this._url);
        const json = await response.json();
        const features = new EsriJSON().readFeatures(json, {
            featureProjection: 'EPSG:3857'
        });
        for (const feature of features) {
            const sitename = feature.get('SITENAME');
            if (sitename) {
                const sitecode = feature.get('SITECODE');
                const url = feature.get('URL');
                const urlContent = url ? `<a href="${url}" target="_blank">read more</a>` : '';
                feature.setProperties({
                    content: `<b>${sitename}</b><br>` +
                        `Site-Code: ${sitecode}<br>` +
                        '<br>' +
                        `${urlContent}`
                });
            }
        }
        this._source.addFeatures(features);
    }
}
